import Axios from 'axios';
import { link } from 'fs';

export function parseTime(time: number|Date, cFormat: string) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = time * 1000;
    date = new Date(time);
  }
  interface formatDate {
    [key: string]: any;
  }
  const formatObj:formatDate = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return timeStr;
}

export function formatTime(time: number|Date, option: string) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - (+d)) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    if (d instanceof Date) {
      return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
    }
  }
}

export function param2Obj(url: string) {
  const search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

export function urlEncode(url: string) {
  return encodeURIComponent(url);
}

export function urlDecode(url: string) {
  return decodeURIComponent(url);
}

export function isIE() {
  var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; // 判断是否IE<11浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE; // 判断是否IE的Edge浏览器
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);');
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp['$1']);
    if (fIEVersion === 7) {
      return 7;
    } else if (fIEVersion === 8) {
      return 8;
    } else if (fIEVersion === 9) {
      return 9;
    } else if (fIEVersion === 10) {
      return 10;
    } else {
      return 6;// IE版本<=7
    }
  } else if (isEdge) {
    return 'edge';// edge
  } else if (isIE11) {
    return 11; // IE11
  } else {
    return -1;// 不是ie浏览器
  }
}
export function isSafari() {
  var userAgent = navigator.userAgent;
  if (userAgent.indexOf('Safari') > -1 && /Version/i.test(userAgent)) {
    var _idx = userAgent.indexOf('Version/');
    var curVer = userAgent.slice(_idx);
    var number = parseInt(curVer.slice(8, 10));
    return number < 11;
  }
}

export function randomString(len?: number) {
  len = len || 32;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var str = '';
  for (let i = 0; i < len; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return str;
}

export function downloadFile(url: string, filename: string) {
  Axios.get(url, { responseType: 'blob' }).then(res => {
    const { data } = res;
    let blob = new Blob([data]);
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    const event = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    link.dispatchEvent(event);
    window.URL.revokeObjectURL(blobUrl);
  }).catch(err => {
    throw new Error(err);
  });
}
// 判断字符是否为空的方法
export function isEmpty(obj:string) {
  var regu = '^[ ]+$';
  var re = new RegExp(regu);
  if (
    typeof obj === 'undefined' ||
      obj == null ||
      obj === '' ||
      re.test(obj)
  ) {
    return true;
  } else {
    return false;
  }
}
// 保留两位小数 输入框
export function toFixed2(num:string) {
  num = num.replace(/[^\\.\d]/g, ''); // 清除"数字"和"."以外的字符
  num = num.replace(/^\./g, ''); // 验证第一个字符是数字而不是.
  num = num.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的.
  num = num.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');// 只允许输入一个小数点
  num = num.replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
  return num;
}
export function addNum(num1:any,num2:any) {
  var sq1, sq2, m;
    try {
      sq1 = num1.toString().split('.')[1].length;
    } catch (e) {
      sq1 = 0;
    }
    try {
      sq2 = num2.toString().split('.')[1].length;
    } catch (e) {
      sq2 = 0;
    }
    m = Math.pow(10, Math.max(sq1, sq2));
    return (num1 * m + num2 * m) / m;
}
export function mulNum(num1:any,num2:any) {
  var sq1, sq2, m;
    try {
      sq1 = num1.toString().split('.')[1].length;
    } catch (e) {
      sq1 = 0;
    }
    try {
      sq2 = num2.toString().split('.')[1].length;
    } catch (e) {
      sq2 = 0;
    }
    m = Math.pow(10, Math.max(sq1, sq2));
    return (num1 * m * num2 * m) / m/m;
}
export function timeago(dateTimeStamp:any) {
  if (!dateTimeStamp) {
    return ''
  }
  var minute = 1000 * 60; // 把分，时，天，周，半个月，一个月用毫秒表示
  var hour = minute * 60;
  var day = hour * 24;
  var week = day * 7;
  var halfamonth = day * 15;
  var month = day * 30;
  var now = new Date().getTime(); // 获取当前时间毫秒
  var diffValue = now - parseInt(dateTimeStamp) * 1000;// 时间差

  if (diffValue < 0) {
    return;
  }
  var minC = diffValue / minute; // 计算时间差的分，时，天，周，月
  var hourC = diffValue / hour;
  var dayC = diffValue / day;
  var weekC = diffValue / week;
  var monthC = diffValue / month;
  let result = ''
  if (monthC >= 1 && monthC <= 3) {
    result = " " + parseInt(monthC + '') + "月前"
  } else if (weekC >= 1 && weekC <= 3) {
    result = " " + parseInt(weekC + '') + "周前"
  } else if (dayC >= 1 && dayC <= 6) {
    result = " " + parseInt(dayC + '') + "天前"
  } else if (hourC >= 1 && hourC <= 23) {
    result = " " + parseInt(hourC + '') + "小时前"
  } else if (minC >= 1 && minC <= 59) {
    result = " " + parseInt(minC + '') + "分钟前"
  } else if (diffValue >= 0 && diffValue <= minute) {
    result = "刚刚"
  } else {
    var datetime = new Date();
    datetime.setTime(dateTimeStamp);
    var Nyear = datetime.getFullYear();
    var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
    var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
    var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
    var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
    var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
    result = Nyear + "-" + Nmonth + "-" + Ndate
  }
  return result;
}
